import { render, staticRenderFns } from "./EditSliderImage.vue?vue&type=template&id=38c50ddc&scoped=true&"
import script from "./EditSliderImage.vue?vue&type=script&lang=js&"
export * from "./EditSliderImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c50ddc",
  null
  
)

export default component.exports